module.exports = __webpack_public_path__ + "img/mysql-logo.a41f2061.png";